import { filter, isEmpty, pick, split } from 'lodash'

const transformToUpdateCuisineTypeSimpleDetailsArgs = data => ({
  ...pick(data, [
    'description',
    'isErrorProne',
    'position',
    'isExcludedFromSearch',
    'isExcludedFromBrowsing',
  ]),
  synonyms: filter(split(data.synonyms, '\n'), synonym => !isEmpty(synonym)),
})

export default transformToUpdateCuisineTypeSimpleDetailsArgs
